import { IRequireable } from "./IRequireable";
import { Requirement } from "./Requirement";
import { RequirementItem } from "./RequirementItem";

export class SingleItemRequirement<T extends IRequireable> extends Requirement {
	public static readonly $type = {
		DataFieldTemplate: "SingleItemRequirement<DataFieldTemplate>",
		ComponentTemplate: "SingleItemRequirement<ComponentTemplate>"
	};
	public readonly $type: string = SingleItemRequirement.$type.DataFieldTemplate;

	public isRepeatable!: boolean;
	public item!: RequirementItem<T>;

	constructor(genericTypeName: "DataFieldTemplate" | "ComponentTemplate") {

		super();

		this.$type = `${"SingleItemRequirement"}<${genericTypeName}>`;
	}

	public static sort<R>(a: SingleItemRequirement<R>, b: SingleItemRequirement<R>) {

		// Return Sort Integer
		return a.item.initialOrder - b.item.initialOrder;
	}
}
